import { useState } from 'react';
import { HttpStatusCode } from 'axios';
import { useCallback } from 'react';
import { useDocumentService } from 'services';
import { AttachedDocument } from 'types';
import _ from 'lodash';

const MIME_TYPES: Record<string, string> = {
    "pdf": "application/pdf",
    "csv": "text/csv",
    "xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "xls": "application/vnd.ms-excel",
    "docx": "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "doc": "application/msword",
    "png": "image/png",
    "jpg": "image/jpeg",
    "jpeg": "image/jpeg",
    "gif": "image/gif",
    "txt": "text/plain",
    "msg": "application/vnd.ms-outlook"
}

export default function useBackupDocument() {
    const documentService = useDocumentService();
    const [showError, setShowError] = useState<boolean>(false);
    const [errorIdentifier, setErrorIdentifier] = useState<string>("");
    
    const downloadDocument = useCallback(async ({ documentUrl, documentName, fileExtension }: AttachedDocument) => {
        const response = await documentService?.getDocumentByUrl(documentUrl);
        
        if (!response || response.status === HttpStatusCode.NotFound || response.status === HttpStatusCode.BadRequest) {
            setErrorIdentifier(documentName);
            setShowError(true);
            return;
        }

        if (response.data) {
            const fileType = fileExtension ? fileExtension.toLowerCase() : "";
            const mimeType = MIME_TYPES[fileType] || "application/octet-stream";

            const file = new Blob([response.data as Blob], { type: mimeType });

            const url = window.URL.createObjectURL(file);
            const a = document.createElement("a");
            a.href = url;
            a.target = "_blank";

            const fileEndsWithExtension = documentName.endsWith(fileExtension || "");
            a.download = `${documentName}${fileEndsWithExtension ? "" :  `.${fileExtension?.toLocaleLowerCase()}`}`;
            a.click();
            window.URL.revokeObjectURL(url);
        }
    }, [documentService]);

    return Object.assign(downloadDocument, {
        showError,
        setShowError,
        errorIdentifier
    });
}